import $ from 'jquery';

export default () => {
    $('.visibility_switch').each(function(k, v) {
        let $me = $(v),
            on_value = $me.data('on'),
            off_value = $me.data('off'),
            $target = $($me.data('target'));

        $me.on('change', function(ev) {
            if ($me.val() == off_value) {
                $target.addClass('is-hidden');
            } else {
                $target.removeClass('is-hidden');
            }
        })
    });
}
